/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { serializeError } from "serialize-error";

import { ViennaUser } from "@vienna/common";

import { clientLogger } from "src/lib/logging/datadog";

interface TrackProps {
  event: string;
  userId?: string;
  anonymousId?: string;
  properties?: object;
  options?: object;
  callback?: Function;
}

export const safeSegmentTrack = ({ event, ...rest }: TrackProps): void => {
  // don't track events from SSR
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.analytics.track(event, rest);
  } catch (err) {
    clientLogger.error("Error with segment event track", { inner: serializeError(err) });
  }
};

interface IdentifyProps {
  userId?: string;
  traits?: object;
}

export const safeSegmentIdentify = ({ userId, traits }: IdentifyProps): void => {
  try {
    window.analytics.identify(userId, traits);
  } catch (err) {
    clientLogger.error("Error with segment identify", { inner: serializeError(err) });
  }
};

export const identifySegmentUser = (currentUser: ViennaUser): void => {
  safeSegmentIdentify({
    userId: currentUser.id,
    traits: {
      username: currentUser.username,
      name: currentUser.displayName,
      email: currentUser.email,
      createdAt: currentUser.createdAt,
    },
  });
};
